const Confirmation = ({ onConfirm, cancel, size, confirmation }) => {
  return (
    <div className="frow flex-1 items-center btn-confirmable-confirmation">
      <div className="text-center flex-1 text-gray-700 mx-d">
        {confirmation}
      </div>
      <div className="frow flex-3 items-center btn-group">
        <div
          className={clsx('btn btn-secondary flex-1', {
            'btn-xs': size == 'xs'
          })}
          onClick={cancel}
        >
          No
        </div>
        <div
          className={clsx('btn btn-success flex-2', { 'btn-xs': size == 'xs' })}
          onClick={onConfirm}
        >
          Yes
        </div>
      </div>
    </div>
  )
}

export default Confirmation
